import React, { useState } from "react";
import "./RoleTable.css";
import { FiEdit, FiTrash } from "react-icons/fi";
import EditRoleModal from "../EditRoleModal/EditRoleModal";
import DeleteRoleModal from "./DeleteRoleModal/DeleteRoleModal";
import { DeleteRoleAPI } from "../../../utils/APIs/RoleApis";
import { toast } from "react-toastify";

const RoleTable = ({ data = [], page, limit, refreshData }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const handleEdit = (role) => {
    setSelectedRole(role);
    setShowModal(true);
  };

  const handleDelete = (role) => {
    setSelectedRole(role);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!selectedRole?._id) return;

    try {
      setDeleting(true);

      const response=await DeleteRoleAPI(selectedRole._id);
      if(response?.data?.success){
        toast.success(response?.data?.message || "Role Deleted successfully!")
         setShowDeleteModal(false);
        refreshData(); // refresh table after delete
      }
      else{
        toast.error(response?.data?.message ||"Role not deleting")
      }

     
    } catch (error) {
      console.error("Delete role failed:", error);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="role-table-wrapper">
      <table className="role-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Role Name</th>
            <th>Description</th>
            <th>Permissions</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item._id}>
                <td className="td-sr">{(page - 1) * limit + index + 1}</td>
                <td>{item.roleName || "-"}</td>
                <td>{item.description || "-"}</td>
                <td>
                  {item.permissions?.length > 0
                    ? item.permissions.join(", ")
                    : "-"}
                </td>
                <td className="action-col">
                  <button
                    className="chat-btn edit-btn"
                    onClick={() => handleEdit(item)}
                  >
                    <FiEdit size={16} />
                  </button>

                  <button
                    className="chat-btn delete-btn"
                    onClick={() => handleDelete(item)}
                  >
                    <FiTrash size={16} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                No roles available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <EditRoleModal
        isOpen={showModal}
        role={selectedRole}
        onClose={() => setShowModal(false)}
        onUpdated={refreshData}
      />

      <DeleteRoleModal
        isOpen={showDeleteModal}
        role={selectedRole}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        deleting={deleting}
      />
    </div>
  );
};

export default RoleTable;


// import React, { useState } from "react";
// import "./RoleTable.css";
// import { FiEdit, FiTrash } from "react-icons/fi";
// import EditRoleModal from "../EditRoleModal/EditRoleModal";
// import DeleteRoleModal from "./DeleteRoleModal/DeleteRoleModal";

// const RoleTable = ({ data = [] }) => {
// const [showDeleteModal, setShowDeleteModal] = useState(false);
// const [selectedRole, setSelectedRole] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const handleEdit = (role) => {
//     console.log("Edit Role:", role);
//     setShowModal(true)
//   };

//   const handleDelete = (role) => {
//   setSelectedRole(role);
//   setShowDeleteModal(true);
// };
// const confirmDelete = (role) => {
//   console.log("Confirmed delete:", role);
//   setShowDeleteModal(false);
// };

//   return (
//     <div className="role-table-wrapper">
//       <table className="role-table">
//         <thead>
//           <tr>
//             <th>Sr.</th>
//             <th>Role Name</th>
//             <th>Description</th>
//             <th>Status</th>
//             <th>Action</th>
//           </tr>
//         </thead>

//         <tbody>
//           {data.map((item, index) => (
//             <tr key={item.id}>
//               <td>{index + 1}</td>
//               <td>{item.roleName || "-"}</td>
//               <td>{item.description || "-"}</td>
//               <td>{item.status || "-"}</td>
//               <td className="action-col">
//                 <button
//                   className="chat-btn edit-btn"
//                   onClick={() => handleEdit(item)}
//                   title="Edit Role"
//                 >
//                   <FiEdit size={16} />
//                 </button>

//                 <button
//                   className="chat-btn delete-btn"
//                   onClick={() => handleDelete(item)}
//                   title="Delete Role"
//                 >
//                   <FiTrash size={16} />
//                 </button>
//               </td>

//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <EditRoleModal
//         isOpen={showModal}
//         onClose={() => setShowModal(false)}
//       />
//       <DeleteRoleModal
//   isOpen={showDeleteModal}
//   role={selectedRole}
//   onClose={() => setShowDeleteModal(false)}
//   onConfirm={confirmDelete}
// />

//     </div>
//   );
// };

// export default RoleTable;
